import { PricingPolicy, PricingResponse, PenaltyUnit } from "@/classes/pricing";
import { ItemStatusType } from "@/classes/itemStatusType";
import mapKnownValues from "@/utils/mapKnownValues";
import { EntityType } from "@/classes/entity";

export type PricingHistoryAPIResponse = {
  activePolicy: PricingResponse | null;
  inheritedFrom: PricingResponse | null;
};

export default class PricingHistoryItem {
  id = "";
  entity = "";
  entityId = "";
  policy: PricingPolicy = PricingPolicy.kwh;
  rate = 0;
  penalty = 0;
  penaltyDelay = 0;
  penaltyUnit = "";
  startDelay = 0;
  inactivatedAt: Date | null = null; // date
  createdAt = new Date(); // date
  createdBy = "";
  createdByEmail = "";
  stationSerial = "";
  stationQR = "";
  propertyName = "";
  organizationName = "";
  itemStatus: ItemStatusType = ItemStatusType.DISABLED;
  jsonData = null;
  previousJsonData = null;
  previousPenalty = 0;
  previousPenaltyDelay = 0;
  previousPolicy: PricingPolicy = PricingPolicy.kwh;
  previousPricing = "";
  previousRate = 0;
  previousStartDelay = 0;
  previousPenaltyUnit = "";

  constructor(params: Partial<PricingHistoryItem> = {}) {
    mapKnownValues(this, params);
  }

  get entityName() {
    switch (this.entity) {
      case EntityType.STATION:
        return "Station";
      case EntityType.CLUSTER:
        return "Cluster";
      case EntityType.ORGANIZATION:
        return "Organization";
      case EntityType.PROPERTY:
        return "Property";
      case EntityType.PANEL:
        return "Panel";
    }
    return "";
  }
}
